import * as React from 'react';
import classnames from 'classnames';

import { IPropertyBarProps } from '../type';
import { Style, FillType, StrokeType } from '../../../../models/style';

const fillTypeOptions = [
  { label: 'None', value: FillType.None },
  { label: 'Solid', value: FillType.Solid },
  { label: 'Hatch', value: FillType.Hatch },
  { label: 'Cross', value: FillType.Cross },
];

const strokeTypeOptions = [
  { label: 'None', value: StrokeType.None },
  { label: 'Solid', value: StrokeType.Solid },
];

const ShapeProperties = ({ app, onStyleChange }: IPropertyBarProps) => {
  const style = app.get_selection_style() as Style;
  return (
    <>
      <div className="prop-items-group">
        <div className="prop-section-title">Fill</div>
        <div className={classnames('prop-item', 'prop-fill-type')}>
          <div className="flat-options" role="radiogroup" aria-label="Fill Type">
            {fillTypeOptions.map(option => (
              <button
                key={option.value}
                type="button"
                role="radio"
                aria-checked={style.fill_type === option.value}
                className={classnames('flat-option', {
                  'flat-option-active': style.fill_type === option.value,
                })}
                onClick={() => {
                  app.update_selection_style({
                    fill_type: option.value,
                  });
                  onStyleChange?.();
                }}
              >
                {option.label}
              </button>
            ))}
          </div>
        </div>
        <div
          className={classnames('prop-item', 'prop-fill-color', {
            'prop-item-disabled': style.fill_type === FillType.None,
          })}
        >
          <input
            id="fill-color"
            type="color"
            title="Fill Color"
            aria-label="Fill Color"
            disabled={style.fill_type === FillType.None}
            value={style.fill_color.to_rgb_hex()}
            onChange={e => {
              app.update_selection_style({
                fill_color: e.target.value,
              });
              onStyleChange?.();
            }}
          />
        </div>
      </div>
      <div className="prop-items-group">
        <div className="prop-section-title">Stroke</div>
        <div className={classnames('prop-item', 'prop-stroke-type')}>
          <div className="flat-options" role="radiogroup" aria-label="Stroke Type">
            {strokeTypeOptions.map(option => (
              <button
                key={option.value}
                type="button"
                role="radio"
                aria-checked={style.stroke_type === option.value}
                className={classnames('flat-option', {
                  'flat-option-active': style.stroke_type === option.value,
                })}
                onClick={() => {
                  app.update_selection_style({
                    stroke_type: option.value,
                  });
                  onStyleChange?.();
                }}
              >
                {option.label}
              </button>
            ))}
          </div>
        </div>
        <div
          className={classnames('prop-item', 'prop-stroke-color', {
            'prop-item-disabled': style.stroke_type === StrokeType.None,
          })}
        >
          <input
            id="stroke-color"
            type="color"
            title="Stroke Color"
            aria-label="Stroke Color"
            value={style.stroke_color.to_rgb_hex()}
            disabled={style.stroke_type === StrokeType.None}
            onChange={e => {
              app.update_selection_style({
                stroke_color: e.target.value,
              });
              onStyleChange?.();
            }}
          />
        </div>
      </div>
    </>
  );
};

export default ShapeProperties;
